import { NgModule, ErrorHandler } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { HttpClientModule } from '@angular/common/http';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { ApiClient } from './api/api-client';
import { ApiService } from './api/api.service';
import { ErrorService } from './api/error.service';
import { ProfileService } from './shared/services/profile.service';
import { RouterService } from './shared/services/router.service';
import { AlertService } from './api/alert.service';
import { OfflineComponent } from './shared/offline/offline.component';
import { NotificationService } from './shared/notification/notification.service';
import { Angulartics2Module } from 'angulartics2';
import { APP_CONFIG, DIETLESS_CONFIG } from './app.config';
import { environment } from '@app/env';
import { RecipesService } from './recipes/recipes.service';
import { AppPopoversComponent } from './shared/app-popovers/app-popovers.component';
import { AppPopoversService } from './shared/app-popovers/app-popovers.service';
import { ShopcartService } from './services/shopcart.service';
import { ShoplistService } from './services/shoplist.service';
import { AppService } from './services/app.service';
import { StoreRouterConnectingModule, RouterStateSerializer } from '@ngrx/router-store';
import { StoreModule, MetaReducer } from '@ngrx/store';
import { EffectsModule, Effect } from '@ngrx/effects';
import bugsnag from '@bugsnag/js';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
import { reducers, effects, CustomSerializer } from './store';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { storeFreeze } from 'ngrx-store-freeze';
import { IconsModule } from './icons/icons.module';

export const metaReducers: MetaReducer<any>[] = !environment.production ? [storeFreeze] : [];

export function appBaseHrefFactory() {
  return environment.BASE_HREF;
}

const routes: Routes = [
  {
    path: '',
    loadChildren: './shell/shell.module#ShellModule'
  }
];

const bugsnagClient = bugsnag('edd2e3806dc146f07b5d2fcfea699597');
window['Bugsnag'] = bugsnagClient;

// create a factory which will return the bugsnag error handler
export function bugsnagErrorHandlerFactory() {
  return new BugsnagErrorHandler(bugsnagClient);
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    CollapseModule,
    AlertModule.forRoot(),
    TooltipModule,
    HttpClientModule,
    AuthModule,
    SharedModule.forRoot(),
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: environment.isCordova ? true : false
    }),
    Angulartics2Module.forRoot(),
    StoreModule.forRoot(reducers, { metaReducers }),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot(effects),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    IconsModule
  ],
  declarations: [AppComponent, AppPopoversComponent, OfflineComponent],
  providers: [
    { provide: APP_BASE_HREF, useFactory: appBaseHrefFactory },
    { provide: APP_CONFIG, useValue: DIETLESS_CONFIG },
    { provide: RouterStateSerializer, useClass: CustomSerializer },
    { provide: ErrorHandler, useFactory: bugsnagErrorHandlerFactory },
    ApiClient,
    ApiService,
    ErrorService,
    AlertService,
    ProfileService,
    RecipesService,
    NotificationService,
    AppPopoversService,
    RouterService,
    AppService,
    ShoplistService,
    ShopcartService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {}
}
